import axios from "axios"

/**
 * Sentry `beforeSend` hook — return `null` to drop the event.
 *
 * Drops:
 *   - Any axios error (HTTP failures like 422/419 are handled in-app)
 *   - VCalendar's transient `dayIndex` error
 */
export default function sentryBeforeSend(event, hint) {
  const error = hint?.originalException

  if (axios.isAxiosError?.(error)) {
    return null
  }

  const message = typeof error === "string" ? error : error?.message
  if (typeof message === "string" && message.includes("dayIndex")) {
    return null
  }

  return event
}
